<template></template>

<script>
/*
    props
    -----

    productId - the id of the product
    versionId - the id of the currently selected version.
    type - either "General" or "Generic Entities"
    name - the "name" property of a "groupItem"

    methods
    -------

    handleNewValue(newValue:String)
    handleNewValueWithSync(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error
*/

import axios from 'axios';
import moment from 'moment';

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'product-details-general-api-handler',
    props: {
        productId: Number,
        versionId: {
            type: [String, Number]
        },
        type: String,
        name: String
    },
    data() {
        return {};
    },
    methods: {
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        saveNewValue(newValue, shouldSync) {
            this.$emit('in-progress');
            axios.post(base_url + '/pimapi/products/' + this.productId + '/details_by_name', {
                "versionId": this.versionId,
                "type": this.type,
                "name": this.name,
                "shouldSync": shouldSync,
                "value": newValue
            })
            .then((response) => {
                this.$emit('success', newValue);
            })
            .catch((error) => {
                if (error.response) {
                    this.$emit('error', error.response.data);
                } else {
                    this.$emit('error', error);
                }
            });
        },
        scheduleNewValue(newValue, scheduleTo) {
            this.$emit('in-progress');
            axios.post(base_url + '/pimapi/products/' + this.productId + '/schedule_details_by_name', {
                "scheduleTo": scheduleTo,
                "value": newValue,
                "versionId": this.versionId,
                "type": this.type,
                "name": this.name
            })
            .then((response) => {
                this.$emit('success', response);
            })
            .catch((error) => {
                if (error.response) {
                    this.$emit('error', error.response.data);
                } else {
                    this.$emit('error', error);
                }
            });
        }
    }
}
</script>